export default "__VITE_ASSET__DKM$KoXD__"